<router-outlet></router-outlet> <crm-tgbot-busy-loader></crm-tgbot-busy-loader>
